import React from "react";
import { Form, Select, Button, Row, Col, Card } from "antd";
import Cookies from "universal-cookie";
import {BaseFile } from "../../RestAPI/dbo/BaseUrl";
import { DownloadOutlined } from "@ant-design/icons";

const { Option } = Select;

function Salary() {
    const currentYear = new Date().getFullYear();
    const persianYear = currentYear - 621;
    const years = Array.from({ length: persianYear - 1400 + 1 }, (_, i) => 1400 + i);
    const months = [
        { value: 1, label: "فروردین" },
        { value: 2, label: "اردیبهشت" },
        { value: 3, label: "خرداد" },
        { value: 4, label: "تیر" },
        { value: 5, label: "مرداد" },
        { value: 6, label: "شهریور" },
        { value: 7, label: "مهر" },
        { value: 8, label: "آبان" },
        { value: 9, label: "آذر" },
        { value: 10, label: "دی" },
        { value: 11, label: "بهمن" },
        { value: 12, label: "اسفند" },
    ];

    const handleDownload = (values: any) => {
        var token =new Cookies().get("user").Token;
        var url=BaseFile+"file/GetPDFFileFishSalaryPerson?year="+values.year+"&month="+values.month+"&token="+token;
        window.open(url)
    };

    return (
        <>
            <Card  title="دانلود فیش حقوقی" style={{margin:15,height:"60vh",direction:"rtl"}}>
                <Form
                    layout="vertical"
                    onFinish={handleDownload}
                    style={{ maxWidth: "600px", margin: "auto" }}
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                name="year"
                                label="سال"
                                rules={[{ required: true, message: "لطفاً یک سال انتخاب کنید!" }]}
                            >
                                <Select placeholder="انتخاب سال">
                                    {years.map((year) => (
                                        <Option key={year} value={year}>
                                            {year}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                name="month"
                                label="ماه"
                                rules={[{ required: true, message: "لطفاً یک ماه انتخاب کنید!" }]}
                            >
                                <Select placeholder="انتخاب ماه">
                                    {months.map((month) => (
                                        <Option key={month.value} value={month.value}>
                                            {month.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block icon={<DownloadOutlined />} >
                                    دانلود
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>

        </>

    );
};
export default Salary;